import { useState } from "react";

const FALLBACK =
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600">
      <defs>
        <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#0c1a30"/>
          <stop offset="100%" style="stop-color:#030812"/>
        </linearGradient>
      </defs>
      <rect width="800" height="600" fill="url(#g)"/>
      <circle cx="400" cy="280" r="60" fill="none" stroke="#55d0ff" stroke-width="2" opacity="0.4"/>
      <text x="400" y="380" text-anchor="middle" fill="#8ea6c8" font-family="sans-serif" font-size="18">TOP WASH</text>
    </svg>`,
  );

/**
 * Pouzdane Unsplash URL-ove gradimo sa fiksnim parametrima.
 */
export function unsplash(id, w = 1200, h = null) {
  const params = new URLSearchParams({
    auto: "format",
    fit: "crop",
    w: String(w),
    q: "85",
  });
  if (h) params.set("h", String(h));
  return `https://images.unsplash.com/${id}?${params}`;
}

export const IMAGES = {
  hero: {
    background: unsplash("photo-1631049307264-da0ec9d70304", 2400, 1600),
    backgroundAlt: "Luksuzna hotelska soba sa besprekorno belom posteljinom",
    mosaic: [
      {
        src: unsplash("photo-1618773928121-c32242e63f39", 800, 1000),
        alt: "Hotelska posteljina",
        label: "Hoteli",
      },
      {
        src: unsplash("photo-1414235077428-338989a2e8c0", 800, 1000),
        alt: "Restoranski sto sa stolnjakom",
        label: "Restorani",
      },
      {
        src: unsplash("photo-1540555700478-4be289fbecef", 800, 1000),
        alt: "Spa peškiri i frotir",
        label: "Spa & wellness",
      },
      {
        src: unsplash("photo-1556910103-1c02745aae4d", 800, 1000),
        alt: "Profesionalna kuhinja i uniforme",
        label: "Uniforme",
      },
    ],
  },
  business: unsplash("photo-1564501049412-61c2a3083791", 1920, 1080),
  services: {
    "hotelska-posteljina-jastuci": unsplash("photo-1618773928121-c32242e63f39", 1200, 800),
    "stolnjaci-salvete": unsplash("photo-1414235077428-338989a2e8c0", 1200, 800),
    "peskir-frotir-spa": unsplash("photo-1540555700478-4be289fbecef", 1200, 800),
    "radne-uniforme": unsplash("photo-1556910103-1c02745aae4d", 1200, 800),
    "jorgani-prekivaci-cebad": unsplash("photo-1596394516093-501ba68a0ba6", 1200, 800),
    "rotacija-dostava": unsplash("photo-1586528116311-ad8dd3c8310d", 1200, 800),
  },
};

export { FALLBACK };
